import actionConsts from "./../../constants/actions";
import { mails } from "../../fakeApi/postResponseMails";

const meetings = (state = [], action = {}) => {
	const { payload } = action;
	switch (action.type) {
		case actionConsts.SET_MAILS:
			return [
				...state,
				...payload.mails.filter(mail => {
					return mail.type === "meeting";
				})
			];

		case actionConsts.RESTART_TUTORIAL:
			return [];

		case actionConsts.ADD_SHOW_MEETING_FLAG:
			return state.map(meeting => {
				if (meeting.id === payload.meeting.id) {
					return {
						...meeting,
						receivedAtTime: payload.expectedAtTime
					};
				}
				return meeting;
			});

		default:
			return state;
	}
};

export default meetings;



// WEBPACK FOOTER //
// /src/reducers/meeting/index.js